/* eslint-disable react/prefer-stateless-function,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import {
  changeFieldGeoTargetChangeTypeComparison,
  changeFieldGeoTargetToggleItem
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectFieldGeoTarget } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';

import {
  selectIdsByGroupId,
  selectItemById,
  selectRequestsStateByGroupId,
  dataRequest
} from 'mt-react-common/common/reducers/listsCollection/reducer';

import MediumPreLoader from '../../../../../Common/PreLoaders/MediumPreLoader';
import CitiesLayer from './CitiesLayer';

const regionsCollectionRN = 'localeModule.collections.regionsCollection';

class RegionsLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (
      this.props.fieldGeoTargetCountry.typeComparison !== null &&
      !this.props.regionsIds.length > 0
    ) {
      this.props.dataRequestRegions();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.fieldGeoTargetCountry.typeComparison !==
        this.props.fieldGeoTargetCountry.typeComparison &&
      !this.props.regionsIds.length > 0
    ) {
      this.props.dataRequestRegions();
    }
  }

  render() {
    let regionsFragment = null;
    if (this.props.selectRegionsRequestsState.requestInProcess) {
      regionsFragment = (
        <div>
          <MediumPreLoader />
        </div>
      );
    } else if (
      this.props.fieldGeoTargetCountry.typeComparison !== null &&
      this.props.regionsIds.length > 0
    ) {
      regionsFragment = this.props.regionsIds.map(regionId => {
        const item = this.props.selectRegionById(regionId);
        const isChecked = Object.keys(
          this.props.fieldGeoTargetCountry.regions
        ).includes(item.iso_code);
        const isCrossedOutClass =
          (this.props.fieldGeoTargetCountry.typeComparison === '1' &&
            !isChecked) ||
          (this.props.fieldGeoTargetCountry.typeComparison === '0' &&
            isChecked);
        return (
          <div>
            <div
              key={`countryCheckbox${item.iso_code}`}
              className="checkbox abc-checkbox abc-checkbox-primary"
            >
              <input
                id={`country${item.iso_code}`}
                className="styled"
                type="checkbox"
                checked={isChecked}
                value={item.iso_code}
                onChange={() =>
                  this.props.changeFieldGeoTargetToggleRegion(item.iso_code)
                }
              />
              <label
                htmlFor={`country${item.iso_code}`}
                className={isCrossedOutClass ? 'crossed-out' : null}
              >
                {item.name}
              </label>
            </div>
            {isChecked ? (
              <CitiesLayer
                reducerName={this.props.reducerName}
                countryIsoCode={this.props.countryIsoCode}
                regionIsoCode={item.iso_code}
              />
            ) : null}
          </div>
        );
      });
    }
    return (
      <React.Fragment>
        <div style={{ padding: '10px 0 10px 20px' }}>
          <div className="form-group">
            <div className="control-group" id="geoTargetRegionsTypeComparison">
              <div
                className="radio abc-radio radio-inline"
                data-target="#manual-check"
              >
                <input
                  defaultChecked={
                    this.props.fieldGeoTargetCountry.typeComparison === null
                  }
                  onChange={() => this.props.changeRegionsTypeComparison(null)}
                  id={`region${this.props.countryIsoCode}TypeComparisonNull`}
                  name={`region${this.props.countryIsoCode}Group`}
                  type="radio"
                />
                <label
                  htmlFor={`region${this.props.countryIsoCode}TypeComparisonNull`}
                >
                  <div className="text-strong m-b-4">Все регионы</div>
                </label>
              </div>
              <div
                className="radio abc-radio radio-inline"
                data-target="#auto-check"
              >
                <input
                  defaultChecked={
                    this.props.fieldGeoTargetCountry.typeComparison === '1'
                  }
                  onChange={() => this.props.changeRegionsTypeComparison('1')}
                  id={`region${this.props.countryIsoCode}TypeComparisonAccept`}
                  name={`region${this.props.countryIsoCode}Group`}
                  type="radio"
                />
                <label
                  htmlFor={`region${this.props.countryIsoCode}TypeComparisonAccept`}
                >
                  <div className="text-strong m-b-4">Включить регионы</div>
                </label>
              </div>
              <div
                className="radio abc-radio radio-inline"
                data-target="#auto-check"
              >
                <input
                  defaultChecked={
                    this.props.fieldGeoTargetCountry.typeComparison === '0'
                  }
                  onChange={() => this.props.changeRegionsTypeComparison('0')}
                  id={`region${this.props.countryIsoCode}TypeComparisonExclude`}
                  name={`region${this.props.countryIsoCode}Group`}
                  type="radio"
                />
                <label
                  htmlFor={`region${this.props.countryIsoCode}TypeComparisonExclude`}
                >
                  <div className="text-strong m-b-4">Исключить регионы</div>
                </label>
              </div>
            </div>
          </div>
          {regionsFragment}
        </div>
      </React.Fragment>
    );
  }
}

RegionsLayer.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,
  countryIsoCode: PropTypes.string.isRequired,

  fieldGeoTargetCountry: PropTypes.shape({
    typeComparison: PropTypes.any.isRequired,
    regions: PropTypes.shape.isRequired
  }).isRequired,

  changeRegionsTypeComparison: PropTypes.func.isRequired,
  changeFieldGeoTargetToggleRegion: PropTypes.func.isRequired,

  regionsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectRegionById: PropTypes.func.isRequired,
  dataRequestRegions: PropTypes.func.isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  selectRegionsRequestsState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  fieldGeoTargetCountry: selectFieldGeoTarget(state, props.reducerName).value
    .countries[props.countryIsoCode],
  regionsIds: selectIdsByGroupId(
    state,
    regionsCollectionRN,
    props.countryIsoCode
  ),
  selectRegionById: id => selectItemById(state, regionsCollectionRN, id),
  selectRegionsRequestsState: selectRequestsStateByGroupId(
    state,
    regionsCollectionRN,
    props.countryIsoCode
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  changeRegionsTypeComparison: value =>
    dispatch(
      changeFieldGeoTargetChangeTypeComparison(
        props.reducerName,
        props.countryIsoCode,
        null,
        value
      )
    ),
  dataRequestRegions: () =>
    dispatch(dataRequest(regionsCollectionRN, props.countryIsoCode)),
  changeFieldGeoTargetToggleRegion: regionIsoCode =>
    dispatch(
      changeFieldGeoTargetToggleItem(
        props.reducerName,
        props.countryIsoCode,
        regionIsoCode
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegionsLayer);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/GeoTargetTaskInputs/CountriesLayer/RegionsLayer/RegionsLayer.js